﻿<script>
    import { onMount } from 'svelte';

    import FormRow from './FormRow.svelte';
    import FormColumn from './FormColumn.svelte';
    import Select from './Select.svelte';
    
    export let id = null;
    export let label = null;
    export let value;
    export let startValue = null;
    export let startYear = 2000;
    export let endYear = new Date().getFullYear();
    export let requiredLabel = null;
    export let requiredYear = null;
    export let requiredMonth = null;
    export let requiredDay = null;
    export let disabled = null;

    let day = "";
    let month = "";
    let year = "";

    let months = [];
    let years = [];
    let days = [];

    let disabledDay = true;
    let disabledMonth = true;

    let initialised = false;

    const monthsArray = [
        { label: "January", value: "01" },
        { label: "February", value: "02" },
        { label: "March", value: "03" },
        { label: "April", value: "04" },
        { label: "May", value: "05" },
        { label: "June", value: "06" },
        { label: "July", value: "07" },
        { label: "August", value: "08" },
        { label: "September", value: "09" },
        { label: "October", value: "10" },
        { label: "November", value: "11" },
        { label: "December", value: "12" },
    ];

    const daysInMonth = (year, month) => {
        console.log("daysInMonth", new Date(year, month, 0).getDate());
        return new Date(year, month, 0).getDate();
    };

    const getDays = (year, month) => {
        if (year && month) {
            const numberOfDays = daysInMonth(year, month);

            days=[];
            for (let i = 1; i <= numberOfDays; i++) {

                if(i < 10){
                    days.push({ label: "0"+i+"", value: "0"+i+"" });
                }else{
                    days.push({ label: i+"", value: i+"" });
                }
            }

            if (day > numberOfDays) {
                day = "";
            }

            return days;
        }
        return [];
    };

  

    const getYears = (startValue, startYear, endYear) => {
        if (startValue) {
            let c = startValue.split("/");
            if (c.length > 1) {
                startYear = c[1];
            }
        }

        let a = [];
        for (let i = startYear; i <= endYear; i++) {
            a.push({ label: i+"", value: i+"" });
        }

        return a;
    }

    const getMonths = (startValue, year) => {
        if (startValue && year) {
            let c = startValue.split("/");
            if (c.length > 1 && year == c[1]) {
                let index = monthsArray.findIndex(m => m.value == c[0]);
                if (index >= 0) {
                    monthsArray.splice(0, index);
                }
            }
        }

        return monthsArray;
    }

    const setupDayDisplay = () => {
        if (disabled){
            disabledDay = disabled;
        }else if (year && month && !disabled){
            disabledDay = false;
        }else{
            disabledDay = true;
        }

        if (year && !disabled){
            disabledMonth = false;
        }else{
            disabledMonth = true;
        }
    }

    const handleChange = (day, month, year) => {
        if (!initialised) return;

        if (year) {
            value = `${year ? year : ""}`;

            if (month) {
                value = `${month ? month : ""}/${value}`;

                if (day) {
                    value = `${day ? day : ""}/${value}`;
                }
            }
        }

        setupDayDisplay();
    }

    onMount(() => {
        months = getMonths(startValue, year);
        years = getYears(startValue, startYear, endYear);
        days = getDays(year, month);

        if (value) {
            const c = value.split("/");
            if (c.length === 1){
                year = c[0];
            }
            else if (c.length === 2){
                month = c[0];
                year = c[1];
            }else if (c.length === 3){
                day = c[0];
                month = c[1];
                year = c[2];
            }
        }

        setupDayDisplay();

        initialised = true;
    })

    $: months = getMonths(startValue, year);
    $: years = getYears(startValue, startYear, endYear);
    $: days = getDays(year, month);
    $: handleChange(day,month, year);

</script>

<FormRow class="mt-0">
    {#if label}
    <FormColumn cols="12">
        <label for="year-{id || ''}">
            {label}
		    {#if label && requiredLabel}
			    <span class="required">*</span>
		    {/if}
        </label>
    </FormColumn>
    {/if}
    <FormColumn cols="3">
        <Select id="year-{id || ''}"
            sublabel="Year"
            optionList={years}
            bind:value={year}
            required={requiredYear}
            sublabelRequired={requiredYear}
            {disabled}></Select>
    </FormColumn>
    <FormColumn cols="6">
        <Select id="month-{id || ''}"
            sublabel="Month"
            optionList={months}
            bind:value={month}
            required={requiredMonth}
            disabled={disabledMonth}></Select>
    </FormColumn>
    <FormColumn cols="3">
        <Select id="day-{id || ''}"
            sublabel="Day"
            optionList={days}
            bind:value={day}
            required={requiredDay}
            disabled={disabledDay}></Select>
    </FormColumn>
</FormRow>
